import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Text, TextInput, keyboard, FlatList } from 'react-native';
// import Screen from '../components/Screen';
// import UploadScreen from './UploadScreen';
// import * as Progress from "react-native-progress";
import colors from '../config/colors';
import { MaterialCommunityIcons } from "@expo/vector-icons";
import defaultStyles from "../config/styles";
import dateNow from '../utility/dateNow';
import connectionConfig from "../config/settings";
import configurationPost from "../config/configurationPost";
import { ListItem } from '../components/lists';
import ActivityIndicator from '../components/ActivityIndicator';
import AuthContext from "../auth/context";

function CommentsPublicationScreen({ route, navigation }) {
    const [ progress, setProgress ] =  useState(0) // para que es 
    const [uploadVisible, setUploadVisible] = useState(false);
    const [ items, setItems ] =  useState([]) // Es para jalar el item---
    const [ commentBoxText, setCommentBoxText ] =  useState('') // para que jale el comentario 
    const [loading, setLoading] = useState(false);
    const { user, setUser } = useContext(AuthContext);
    //const { user } = useAuth();
    const date = dateNow();
    var profileUri =  connectionConfig.imageUrl +'/PerfilDeUsuario/'
    var numComments = 0 

    useEffect(( ) => { 
        // keyboard.addListener('Keyboard Shown' )
        // setUploadVisible(true)
        // setProgress(0.3)
        getComments()
        //debugger
    }, [])

//---------------------------------------------------------------------------------------
//Agrega un comentario a una publicación. 1 *Función inicio de la encadenación de servicios.
//---------------------------------------------------------------------------------------
    const uploadComment = async () => {
       // debugger
       var post_values = {
        userPublicationId: route.params.userPublicationId , 
        userIdPublisherComment: JSON.parse(user).userId,
        dateComment: date,
        commentBox: commentBoxText,
        }
       configurationPost.body = JSON.stringify(post_values)
       await fetch(connectionConfig.apiUrl+'/fixoUsers/insertCommentPublication/', configurationPost)
       .then(response => response.json())
       .then(response => {
            setCommentBoxText('') 
            setLoading(true)
            getNumComments()  
       })
       .catch(err =>{
            console.log(':( review internet service', err )
       })
}
    
//----------------------------------------------------------
// Traer la cuenta de los comentarios de una publicación 2 *
//----------------------------------------------------------
const getNumComments = async () => {
        //debugger
         var post_values = {
         userPublicationId: route.params.userPublicationId,
         }
        configurationPost.body = JSON.stringify(post_values)
        await fetch(connectionConfig.apiUrl+'/fixoUsers/SelectCountComments/', configurationPost)
        .then(response => response.json())
        .then(response => {
             numComments = response.data[0].total_comments
             incrementComments()
         })
        .catch(err =>{
        console.log(':( review internet service', err )
        })
}

//-----------------------------------------------------------------
//servicio que hace un incremeto al campo de número de comments 3 * 
//-----------------------------------------------------------------
const incrementComments = async () => {
    debugger
    var post_values = {
      userPublicationId: route.params.userPublicationId , 
      totalComments : numComments
  }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/fixoUsers/UpdateIncrementCommentPublication/', configurationPost) 
  .then(response => response.json())
  .then(response => {
    getComments()
  })
  .catch(err =>{
  console.log('Insert fixo failed :( review internet service', err )
  })
}

//---------------------------------------------
//Traer los comentarios de la publicación 4 * Término de la encadenacion
//---------------------------------------------
const getComments = async () => {
       //debugger
        var post_values = {
        userPublicationId: route.params.userPublicationId,
        }
       configurationPost.body = JSON.stringify(post_values)
       await fetch(connectionConfig.apiUrl+'/fixoUsers/SelectCommentsPublication/', configurationPost)
       .then(response => response.json())
       .then(response => {
            setItems(response.data)
            setLoading(false)
        })
       .catch(err =>{
       console.log(':( review internet service', err )
    })
}
    
return (
    <>
        {/* <View style={styles.container}> */}
             <FlatList
                  data={items}
                  keyExtractor={(items) => items.commentsPublicationsId.toString()}                  
                  renderItem={({ item, index}) => (
                    <ListItem
                    image={profileUri + item.userId + '_' + item.userPhoto}
                    titleRol={item.userName}
                    subTitle={item.commentBox}
                    onPress={ () => {
                         console.log('hola', index)
                         props.navigation.navigate(routes.FOUND_USER, {item, index})
                         }} 
                    >                       
                    </ListItem>   
                  )}>
             </FlatList>
             <ActivityIndicator visible={loading} />
            <View style={styles.containerSearch}>                    
                    <TextInput style={styles.input}
                        onChangeText = {text => setCommentBoxText(text)}
                        placeholder = "Comment"
                        value = {commentBoxText}
                        />
                {commentBoxText.trim() === '' ? 
                <MaterialCommunityIcons
                //onPress = {()=> uploadComment()}
                name={"emoticon-happy-outline"}
                size={35}
                color={defaultStyles.colors.medium}
                style={styles.icon}
                />   
                : 
                <MaterialCommunityIcons
                        onPress = {()=> uploadComment()}
                        name={"upload"}
                        size={35}
                        color={defaultStyles.colors.medium}
                        style={styles.icon}
                    />
                }
            </View>
          {/* </View> */}
     </>
    );
}
const styles = StyleSheet.create({
    container:{
        flex: 1,
        position: 'absolute',

    },
    containerSearch:{
        marginTop:"5%",
        flexDirection:"row",
        width:"100%",
        height:"10%"
    },
    input:{
        borderWidth: 1,
        borderColor: colors.medium,
        paddingLeft:5,
        borderRadius: 5,
        width:"70%",
        marginLeft: "10%"
    },
    icon:{
        alignSelf:"center",
        margin:10,
        width:"10%",
    }
})

export default CommentsPublicationScreen;